import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  min-height: 100vh;
  
  @media (max-width: 1024px) {
    padding: 1.5rem;
  }
  
  @media (max-width: 768px) {
    padding: 1rem;
  }
  
  @media (max-width: 480px) {
    padding: 0.5rem;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  
  @media (max-width: 768px) {
    margin-bottom: 1.5rem;
  }
  
  @media (max-width: 480px) {
    margin-bottom: 1rem;
  }
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.ruleDetailsTitleColor};
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  text-align: center;
  
  @media (max-width: 1024px) {
    font-size: 1.6rem;
  }
  
  @media (max-width: 768px) {
    font-size: 1.4rem;
    margin-bottom: 1rem;
  }
  
  @media (max-width: 480px) {
    font-size: 1.2rem;
    margin-bottom: 0.8rem;
  }
`;

export const BackButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 8px;
  
  .icon {
    color: ${({ theme }) => theme.arrowBack};
  }

  svg {
    transition: transform 0.2s ease;
  }

  &:hover svg {
    transform: translateX(-2px);
  }
  
  @media (max-width: 768px) {
    padding: 12px;
    
    .icon {
      width: 28px;
      height: 28px;
    }
  }
  
  @media (max-width: 480px) {
    padding: 10px;
    
    .icon {
      width: 24px;
      height: 24px;
    }
  }
`;

export const DivDetailCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 3rem;
  
  @media (max-width: 768px) {
    margin-top: 2rem;
  }
  
  @media (max-width: 480px) {
    margin-top: 1rem;
  }
`;

export const DetailCard = styled.div`
  background-color: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.cardBorder};
  border-radius: 10px;
  padding: 2rem;
  width: 100%;
  max-width: 800px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 1024px) {
    padding: 1.5rem;
    max-width: 90%;
  }
  
  @media (max-width: 768px) {
    padding: 1.2rem;
    border-radius: 8px;
    max-width: 95%;
  }
  
  @media (max-width: 480px) {
    padding: 1rem;
    border-radius: 6px;
    max-width: 100%;
    margin: 0 0.5rem;
  }
`;

export const RuleIcon = styled.div`
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme, color }) => color || theme.primary};
  color: ${({ theme }) => theme.primaryOn};
  font-size: 32px;
  border-radius: 50%;
  margin: 0 auto 2rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;

export const DetailSection = styled.div`
  margin-bottom: 2rem;
  
  @media (max-width: 768px) {
    margin-bottom: 1.5rem;
  }
  
  @media (max-width: 480px) {
    margin-bottom: 1rem;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 1.2rem;
  font-weight: 500;
  color: ${({ theme }) => theme.text};
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid ${({ theme }) => theme.border};
`;

export const DetailItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
  padding: 0.75rem;
  border-radius: 6px;
  
  &:nth-child(even) {
    background-color: ${({ theme }) => theme.backgroundAlt};
  }
  
  @media (max-width: 768px) {
    margin-bottom: 1.2rem;
    padding: 0.6rem;
  }
  
  @media (max-width: 480px) {
    margin-bottom: 1rem;
    padding: 0.5rem;
    border-radius: 4px;
  }
`;

export const DetailLabel = styled.span`
  font-weight: 600;
  min-width: 120px;
  margin-bottom: 0.5rem;
  color: ${({ theme }) => theme.detailLabelColor};
  font-size: 1.1rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  
  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 0.4rem;
    min-width: 100px;
  }
  
  @media (max-width: 480px) {
    font-size: 0.9rem;
    margin-bottom: 0.3rem;
    min-width: 80px;
    letter-spacing: 0.3px;
  }
`;

export const DetailValue = styled.div`
  color: ${props => props.theme.text};
  font-size: 16px;
  flex: 1;
  word-break: break-word;
  white-space: pre-wrap;
  line-height: 1.5;
  
  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 1.4;
  }
  
  @media (max-width: 480px) {
    font-size: 13px;
    line-height: 1.3;
  }
`;

export const SeverityBadge = styled.span<{ severity: string }>`
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  background-color: ${({ theme, severity }) => 
    severity === 'High' ? theme.error : 
    severity === 'Medium' ? theme.warning : 
    theme.success};
  color: ${({ theme }) => theme.successOn};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const StatusBadge = styled.span<{ status: string }>`
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  background-color: ${({ theme, status }) => 
    status === 'Active' ? theme.success : 
    status === 'Inactive' ? theme.placeholderColor : 
    theme.warning};
  color: ${({ theme }) => theme.warningOn};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const ParametersContainer = styled.div`
  background-color: ${({ theme }) => theme.codeBackground};
  border-radius: 8px;
  padding: 16px;
  font-family: 'Courier New', monospace;
  font-size: 14px;
  color: ${({ theme }) => theme.codeText};
  white-space: pre-wrap;
  word-break: break-word;
  overflow-x: auto;
  margin-top: 8px;
  border: 1px solid ${({ theme }) => theme.cardBorder};
`;

export const SaveButton = styled.button`
  background-color: ${({ theme }) => theme.saveButtonBackground};
  color: ${({ theme }) => theme.saveButtonText};
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  margin-top: 20px;
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
  &:hover {
    background-color: ${({ theme }) => theme.saveButtonHover};
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const FormActions = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  gap: 1rem;
`; 